Object.defineProperty(exports,"__esModule",{value:true});exports.default=




positionHealthStatus;var _securityDeviceHealthStatus=require('./securityDeviceHealthStatus');function positionHealthStatus(
position)
{
var securityDevice=position.getArmDevice();
if(!securityDevice){
return{
type:_securityDeviceHealthStatus.HealthStatus.MISSING_SECURITY_DEVICE};

}var


healthStatus=





securityDevice.healthStatus,healthStatusUpdatedAt=securityDevice.healthStatusUpdatedAt,translatedUnhealthyReason=securityDevice.translatedUnhealthyReason,translatedUnhealthyReasonAction=securityDevice.translatedUnhealthyReasonAction,unhealthyAt=securityDevice.unhealthyAt,securityStatusUpdatedAt=securityDevice.securityStatusUpdatedAt;

if(healthStatus!==null&&healthStatus!==undefined){
return(0,_securityDeviceHealthStatus.createHealthStatus)(
healthStatus,
translatedUnhealthyReason,
translatedUnhealthyReasonAction,
unhealthyAt||healthStatusUpdatedAt);

}else if(healthStatus===null&&healthStatusUpdatedAt===null){
return{
type:_securityDeviceHealthStatus.HealthStatus.HEALTHY,
payload:{
message:'',
action:null,
since:securityStatusUpdatedAt}};


}else{
return{
type:_securityDeviceHealthStatus.HealthStatus.UNKNOWN};

}
}